<template>
  <v-dialog v-model="dialog" width="500" @click:outside="outsideCLicked">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <slot />
      </div>
    </template>
    <v-card>
      <v-card-text>
        <v-row v-show="error">
          <v-col cols="12" sm="12" md="12">
            <v-alert type="error" border="left">{{ error }}</v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <base-material-card>
              <template v-slot:heading>
                <div class="display-2 font-weight-light"></div>
                <v-btn-toggle v-model="signup">
                  <v-btn>Login</v-btn>
                  <v-btn>Sign Up</v-btn>
                </v-btn-toggle>
              </template>
              <v-form>
                <v-container class="py-0">
                  <v-row align="center" justify="center" v-if="!signup">
                    <v-btn-toggle v-model="withOtp">
                      <v-btn>With Password</v-btn>
                      <v-btn>With OTP</v-btn>
                    </v-btn-toggle>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" v-if="signup">
                      <v-text-field
                        :label="$i18n.t('Full Name')"
                        prepend-icon="person"
                        v-model="user.name"
                      />
                    </v-col>
                    <v-col cols="12" md="12">
                      <v-row>
                        <v-col cols="12" md="5">
                          <z-country-select
                            preIcon="mdi-earth"
                            type="number"
                            v-model="user.countryCode"
                            hideName
                            isd
                            :label="$i18n.t('Code')"
                          />
                        </v-col>
                        <v-col cols="12" md="7" v-if="!signup">
                          <v-text-field
                            :label="$i18n.t('Phone') + '/' + $i18n.t('Email')"
                            name="login"
                            prepend-icon="phone"
                            v-model="user.emailPhone"
                          />
                        </v-col>
                        <v-col cols="12" md="7" v-if="signup">
                          <v-text-field
                            :label="$i18n.t('Phone')"
                            name="login"
                            prepend-icon="phone"
                            v-model="user.phone"
                            type="number"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="12" v-if="signup">
                      <v-text-field
                        :label="$i18n.t('Email')"
                        :disabled="otpSent"
                        prepend-icon="mail"
                        v-model="user.email"
                      />
                    </v-col>
                    <v-col cols="12" md="12" v-if="signup || !withOtp">
                      <v-text-field
                        :label="$i18n.t('Password')"
                        type="password"
                        prepend-icon="lock"
                        v-model="user.password"
                      />
                    </v-col>
                    <v-col cols="12" md="12" v-if="signup">
                      <v-text-field
                        :label="$i18n.t('Confirm Password')"
                        type="password"
                        prepend-icon="lock"
                        v-model="user.cnfPassword"
                      />
                    </v-col>

                    <v-row v-if="!signup && withOtp">
                      <v-col cols="12" md="6">
                        <v-row>
                          <v-col cols="8" md="8">
                            <v-img :src="captchaSrc" />
                          </v-col>
                          <v-col cols="4" md="4">
                            <v-btn @click="handleRefreshCaptchaFloatQuery" text fab>
                              <v-icon>mdi-reload</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :label="$i18n.t('Enter Captcha Value')"
                          prepend-icon="lock"
                          v-model="user.captchaQuery"
                        />
                      </v-col>
                    </v-row>

                    <v-col cols="12" md="12" v-if="!signup && withOtp && otpSent">
                      <v-text-field
                        :label="$i18n.t('OTP')"
                        prepend-icon="lock"
                        v-model="user.password"
                        type="password"
                      />
                    </v-col>
                    <v-col cols="12" md="12" v-if="signup && verificationCodeSent">
                      <v-text-field
                        :label="$i18n.t('Verification Code')"
                        prepend-icon="lock"
                        v-model="user.verifyCode"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-spacer />
                    <v-col cols="6" class="text-right" v-if="signup && !verificationCodeSent">
                      <v-btn
                        color="primary"
                        @click="sendVerifyCode"
                        :loading="loading"
                      >Send Verification Code</v-btn>
                    </v-col>
                    <v-col cols="6" class="text-right" v-if="signup && verificationCodeSent">
                      <v-btn color="primary" @click="signUp" :loading="loading">Signup</v-btn>
                    </v-col>
                    <v-col cols="6" class="text-right" v-if="!signup && !withOtp">
                      <v-btn color="primary" @click="login" :loading="loading">Login</v-btn>
                    </v-col>
                    <v-col cols="6" class="text-right" v-if="!signup && withOtp && !otpSent">
                      <v-btn color="primary" @click="sendOtp" :loading="loading">Send OTP</v-btn>
                    </v-col>
                    <v-col cols="6" class="text-right" v-if="!signup && withOtp && otpSent">
                      <v-btn color="primary" @click="verifyOtp" :loading="loading">Verify</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </base-material-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Component, Vue, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import axios from "axios";

@Component({
  props: {
    showAuthWizard: {
      default: false,
    },
  },
})
export default class Login extends Vue {
  user = {
    name: null,
    phone: null,
    email: null,
    otp: null,
    countryCode: 91,
    password: "",
  };
  authContent = { user_id: null };
  otpSent = false;
  dialog = false;
  withOtp = false;
  signup = false;
  captchaSrc = "/api/o/captcha/login?id=" + new Date().getTime();
  verificationCodeSent = false;

  get loading() {
    return common.loading;
  }

  get error() {
    return common.error;
  }

  @Watch("showAuthWizard")
  async onDialogChange(newVal) {
    common.setError(null);
    common.showMessage(null);
    if (newVal) {
      await this.validateUser();
      this.dialog = this.showAuthWizard;
    }
  }

  outsideCLicked() {
    this.$emit("showAuthWizardUpdate", false);
  }

  async sendVerifyCode() {
    if (!this.user.name) {
      common.setError("Please provide name.");
      return;
    }
    if (!this.user.countryCode) {
      common.setError("Please provide country code.");
      return;
    }
    if (!this.user.phone) {
      common.setError("Please provide phone.");
      return;
    }
    if (!this.user.email) {
      common.setError("Please provide email.");
      return;
    }
    const re = /\S+@\S+\.\S+/;
    if (!re.test(this.user.email)) {
      common.setError("Invalid email provided.");
      return;
    }

    try {
      common.setLoading(true);
      common.setError(null);
      await this.doPost("/api/o/user/b2c/verification", this.user);
      common.setLoading(false);
      common.showMessage("Signup Sucessful.");
      this.verificationCodeSent = true;
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async signUp() {
    if (!this.user.name) {
      common.setError("Please provide name.");
      return;
    }
    if (!this.user.countryCode) {
      common.setError("Please provide country code.");
      return;
    }
    if (!this.user.phone) {
      common.setError("Please provide phone.");
      return;
    }
    if (!this.user.email) {
      common.setError("Please provide email.");
      return;
    }
    const re = /\S+@\S+\.\S+/;
    if (!re.test(this.user.email)) {
      common.setError("Invalid email provided.");
      return;
    }
    if (!this.user.password) {
      common.setError("Invalid provide password.");
      return;
    }
    if (!this.user.cnfPassword) {
      common.setError("Invalid provide confirm password.");
      return;
    }
    if (this.user.password !== this.user.cnfPassword) {
      common.setError("Password missmatch.");
      return;
    }
    if (!this.user.verifyCode) {
      common.setError("Enter verification code.");
      return;
    }
    try {
      common.setLoading(true);
      common.setError(null);
      await this.doPost("/api/o/user/b2c/register", this.user);
      common.setLoading(false);
      common.showMessage("Signup Sucessful.");
      this.signup = false;
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async login() {
    try {
      if (!this.processEmailPhone(true, false)) {
        return;
      }
      common.setLoading(true);
      common.setError(null);
      await this.doPost("/api/o/login", this.user);
      common.setLoading(false);
      this.validateUser();
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  processEmailPhone(passCheck, captchaChek) {
    if (this.user.emailPhone) {
      if (isNaN(parseInt(this.user.emailPhone))) {
        this.user.email = this.user.emailPhone;
        this.user.phone = null;
      } else {
        this.user.phone = this.user.emailPhone;
        this.user.email = null;
      }
    } else {
      common.setError("Please enter email/phone");
      return false;
    }
    if (passCheck && !this.user.password) {
      common.setError("Please enter password");
      return false;
    }
    if (captchaChek && !this.user.captchaQuery) {
      common.setError("Please enter captcha");
      return false;
    }
    if (this.withOtp) this.user.authType = "otp";
    else this.user.authType = "password";

    return true;
  }

  postAuthentication(authContent) {
    //this.$router.push({ name: "Rate", params: { cargo: this.cargo } });
    this.dialog = false;
    this.$emit("loginsuccess", authContent);
  }

  async verifyOtp() {
    try {
      if (!this.processEmailPhone(true, false)) {
        return;
      }
      common.setLoading(true);
      common.setError(null);
      await this.doPost("/api/o/admin/login", this.user);
      common.setLoading(false);
      this.validateUser();
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  async sendOtp() {
    try {
      if (!this.processEmailPhone(false, true)) {
        return;
      }
      common.setLoading(true);
      common.setError(null);
      await this.doPost("/api/o/send/otp/web", this.user);
      common.setLoading(false);
      common.showMessage(
        "An OTP has been sucessfully sent to your phone/email."
      );
      // this.userOtpSent = Object.assign({}, this.user);
      this.otpSent = true;
    } catch (e) {
      common.setLoading(false);
      common.setError(e.message);
    }
  }

  onDismissed() {
    //this.$store.dispatch("clearError");
  }

  async validateUser() {
    try {
      this.authContent = await this.doGet("/api/webcontent");
      if (this.authContent != null && this.authContent.user_id != null) {
        this.postAuthentication(this.authContent);
      }
    } catch (e) {
      //common.setError(e);
      console.log(e);
    }
  }

  async mounted() {
    //await this.validateUser();
  }

  async doGet(url) {
    try {
      const response = await axios.get(url, {
        headers: { "x-api-key": "WEB" },
      });
      return response.data;
    } catch (error) {
      console.log(url);
      return this.promiseReject(error);
    }
  }
  async doPost(url, payload) {
    try {
      const response = await axios.post(url, payload, {
        headers: { "x-api-key": "WEB" },
      });
      return response.data;
    } catch (error) {
      console.log(url);
      return this.promiseReject(error);
    }
  }

  promiseReject(error) {
    if (
      error &&
      error.response &&
      error.response.status === 400 &&
      error.response.data
    ) {
      const exception = error.response.data;
      if (exception.customMessage) {
        exception.message = exception.message + " " + exception.customMessage;
      }
      return Promise.reject(error.response.data);
    } else if (error && error.response && error.response.status === 401) {
      return Promise.reject({
        status: error.response.status,
        message: "Unauthorized access.",
      });
    }
    return Promise.reject({
      status: error.response.status,
      message: error.message,
    });
  }

  async handleRefreshCaptchaFloatQuery() {
    common.showMessage();
    common.setError();
    this.captchaSrc = "/api/o/captcha/login?id=" + new Date().getTime();
  }
}
</script>
